import { render, staticRenderFns } from "./LiveGame.vue?vue&type=template&id=5ebbfba5"
import script from "./LiveGame.js?vue&type=script&lang=js&external"
export * from "./LiveGame.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports